import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutSecondCoownerLastNameChange = {
  onCheckoutSecondCoownerLastNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};
export default onCheckoutSecondCoownerLastNameChange;
